// extracted by mini-css-extract-plugin
module.exports = {"soldOut":"SoldOut_soldOut__42H28","soldOutDot":"SoldOut_soldOutDot__cIIbT","soldOutText":"SoldOut_soldOutText__EZj8l"};